/** Generate a fake Salesforce ID with the given 3-char prefix (e.g. "006" or "500"). */
export function genSalesforceId(prefix: string): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const suffix = Array.from({ length: 15 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  return prefix + suffix;
}
